export interface RequestWithContent {
  Content: string;
}

export function normalizeJsonContent(content: string): string {
  try {
    const parsed = JSON.parse(content);

    if (typeof parsed === 'string') {
      const nested = JSON.parse(parsed);
      return nested && typeof nested === 'object'
        ? JSON.stringify(nested)
        : content;
    }

    return parsed && typeof parsed === 'object'
      ? JSON.stringify(parsed)
      : content;
  } catch {
    return content;
  }
}

export function serializeRequest<T extends RequestWithContent>(request: T): string {
  return JSON.stringify({
    ...request,
    Content: normalizeJsonContent(request.Content),
  });
}
